<script>
import Attr from './Attr.vue';
import TextNoteExtract from './TextNoteExtract.vue';
import ArtworkSidebarAccordion from './ArtworkSidebarAccordion.vue';
import artworkDetailsMixin from 'mixins/artworkDetailsMixin.js';

import applyHighlights from 'lib/applyHighlights.js';
import { partialStrings, unavailableImage } from 'config';
import { mapState } from 'vuex';
import template from '../../views/partials/single/individual_details.html';

export default {
  data() {
    return {
      partial: partialStrings,
    };
  },
  components: {
    Attr,
    ArtworkSidebarAccordion,
    TextNoteExtract,
  },
  mixins: [artworkDetailsMixin],
  template,
  props: ['artwork', 'rawArtwork'],
  computed: {
    ...mapState('artworks', ['images', 'currentImage']),
    ...mapState('auth', ['currentUser']),
    artistNotes() {
      return this.notes ? this.notes.artist : [];
    },
    artworkNotes() {
      return this.notes ? this.notes.artwork : [];
    },
    cartNotes() {
      return this.notes ? this.notes.cart : [];
    },
    isImageNotAvailable() {
      return this.artwork.image_unavailable;
    },
    imageNotAvailable() {
      return unavailableImage.main[this.artwork.image_unavailable];
    },
    highlightedImages() {
      if (!this.artwork.highlights) return this.images;
      return this.images.map((i) => applyHighlights(i, this.artwork.highlights));
    },
    image() {
      const index = this.currentImage || 0;
      return this.highlightedImages[index] || {};
    },
  },
};
</script>
